export default __webpack_public_path__ + "static/media/bg.becb3ced.jpg";